import { Fileira } from './fileira';
import { ItemPedido } from './pedido';
import { Produto } from './produto';

export class Combinacao {
  painel: ItemPedido;
  inversor: ItemPedido;
  potenciaTotal: number;
  valorTotal: number;
  valorFinal: number;
  itens: ItemPedido[];
}

export class FiltroCombinacao {
  idPainel: number;
  qtdPainel: number;
  fase: number;
  tensao: number;
  idMarca?: number;
  fileiras: Fileira[];
  idProduto: number;
  idFornecedorPainel: number;
  usarTransformador: boolean;
  buscarMicroinversores: boolean;
  potenciaTotal: number;
  idCliente: number;
  descontoIndividual: number;
  percentual: number;
  valorDa: number;
  ibge: string;
  uf: string;
  tipoInv?: number;
  incluirStringBox?: boolean;
  idMarcaStringbox?: number;
  idAgrupamentoStringbox: number;
  agrupamentoStringbox: string;
}

export class CombinacaoLista {
  sistema: string;
  inversor: string;
  idInversor: number;
  valorTotal: number;
  valorFinal: number;
  kitSelecionado: Combinacao;
  imagem$: Promise<any>;
  buscouImagem: boolean;
  idAgrupamentoStringbox: number;
}
